import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { familyApi, errMsg } from './familyApi';
import { inputCls, Field } from './CreateAccountForm';
import { Section, Btn } from './DetailSections';

export const ProfileFields = ({ a, run, busy }) => {
  const [f, setF] = useState({ name: a.name, relationship: a.relationship || '', notes: a.notes || '' });
  useEffect(() => { setF({ name: a.name, relationship: a.relationship || '', notes: a.notes || '' }); }, [a]);
  const dirty = f.name !== a.name || f.relationship !== (a.relationship || '') || f.notes !== (a.notes || '');
  return (
    <Section title="Details & private notes" testId="family-detail-profile">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Field label="Name"><input data-testid="family-detail-edit-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inputCls} /></Field>
        <Field label="Relationship"><input data-testid="family-detail-edit-relationship" value={f.relationship} onChange={(e) => setF({ ...f, relationship: e.target.value })} className={inputCls} /></Field>
      </div>
      <Field label="Private notes"><textarea data-testid="family-detail-edit-notes" rows={3} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} className={inputCls} /></Field>
      <Btn data-testid="family-detail-save-profile" disabled={!dirty || busy || !f.name.trim()} onClick={() => run(() => familyApi.update(a.user_id, f), 'Details saved')}>Save details</Btn>
    </Section>
  );
};

export const DangerZone = ({ a, run, busy, onDeleted, setBusy }) => {
  const terminated = a.access.status === 'terminated';
  const terminate = () => {
    if (!window.confirm(`Terminate ${a.name}'s account? They will be signed out and can no longer log in.`)) return;
    run(() => familyApi.action(a.user_id, 'terminate'), 'Account terminated');
  };
  const remove = async () => {
    if (!window.confirm(`Permanently delete ${a.name}'s account? This cannot be undone.`)) return;
    setBusy(true);
    try { await familyApi.remove(a.user_id); toast.success('Account deleted'); onDeleted(a.user_id); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Section title="Account" testId="family-detail-danger">
      {terminated ? (
        <div className="flex flex-wrap gap-2">
          <Btn tone="green" data-testid="family-detail-reactivate" disabled={busy} onClick={() => run(() => familyApi.action(a.user_id, 'reactivate'), 'Account reactivated')}>Reactivate account</Btn>
          <Btn tone="red" data-testid="family-detail-delete" disabled={busy} onClick={remove}>Delete permanently</Btn>
        </div>
      ) : (
        <Btn tone="red" data-testid="family-detail-terminate" disabled={busy} onClick={terminate}>Terminate account</Btn>
      )}
    </Section>
  );
};
